import PropTypes from 'prop-types'

function WelcomeCard({ icon, title, description, className = '' }) {
  return (
    <div
      className={`bg-surface-light dark:bg-surface-dark rounded-xl shadow-md dark:shadow-md p-6 ${className}`}
    >
      <div className="flex items-start space-x-4">
        <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-primary-600 rounded-lg flex items-center justify-center flex-shrink-0">
          {icon}
        </div>
        <div className="flex flex-col justify-center min-h-12">
          <h3 className="text-lg font-semibold text-neutral-900 dark:text-white">{title}</h3>
          <p className="text-neutral-600 dark:text-neutral-400 mt-1">{description}</p>
        </div>
      </div>
    </div>
  )
}

WelcomeCard.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default WelcomeCard
